import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import InstagramReelsPrompt from './components/prompts/InstagramReelsPrompt';
import InstagramPostPrompt from './components/prompts/InstagramPostPrompt';
import XThreadPrompt from './components/prompts/XThreadPrompt';
import LinkedInArticlePrompt from './components/prompts/LinkedInArticlePrompt';
import EmailCampaignPrompt from './components/prompts/EmailCampaignPrompt';
import AboutUsPrompt from './components/prompts/AboutUsPrompt';
import ProductDescriptionPrompt from './components/prompts/ProductDescriptionPrompt';
import AdCopyPrompt from './components/prompts/AdCopyPrompt';
import BlogPostPrompt from './components/prompts/BlogPostPrompt';
import BlogPostOutlinePrompt from './components/prompts/BlogPostOutlinePrompt';
import ArticlePrompt from './components/prompts/ArticlePrompt';
import VideoScriptPrompt from './components/prompts/VideoScriptPrompt';
import AskAnythingPrompt from './components/prompts/AskAnythingPrompt';
import LandingPagePrompt from './components/prompts/LandingPagePrompt';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsAndConditions from './components/pages/TermsAndConditions';
import Disclaimer from './components/pages/Disclaimer';
import CookiePolicy from './components/pages/CookiePolicy';
import CaliforniaPrivacyRights from './components/pages/CaliforniaPrivacyRights';
import ContactUs from './components/pages/ContactUs';
import ScrollToTop from './components/ScrollToTop';
import SuggestionsPage from './components/feedback/SuggestionsPage';
import { UsageProvider } from './contexts/UsageContext';

function App() {
  return (
    <UsageProvider>
      <div className="min-h-screen bg-gray-50">
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/prompts/instagram-reel" element={<InstagramReelsPrompt />} />
              <Route path="/prompts/instagram-post" element={<InstagramPostPrompt />} />
              <Route path="/prompts/x-thread" element={<XThreadPrompt />} />
              <Route path="/prompts/linkedin-article" element={<LinkedInArticlePrompt />} />
              <Route path="/prompts/email-campaign" element={<EmailCampaignPrompt />} />
              <Route path="/prompts/about-us" element={<AboutUsPrompt />} />
              <Route path="/prompts/product-description" element={<ProductDescriptionPrompt />} />
              <Route path="/prompts/ad-copy" element={<AdCopyPrompt />} />
              <Route path="/prompts/ask-anything" element={<AskAnythingPrompt />} />
              <Route path="/prompts/blog-post" element={<BlogPostPrompt />} />
              <Route path="/prompts/blog-post-outline" element={<BlogPostOutlinePrompt />} />
              <Route path="/prompts/article" element={<ArticlePrompt />} />
              <Route path="/prompts/video-script" element={<VideoScriptPrompt />} />
              <Route path="/prompts/landing-page" element={<LandingPagePrompt />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/california-privacy-rights" element={<CaliforniaPrivacyRights />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/suggestions" element={<SuggestionsPage />} />
            </Route>
          </Routes>
        </Router>
      </div>
    </UsageProvider>
  );
}

export default App;
